// import React from 'react';
// import PageTemplate from './PageTemplate';
// export default function TermsAndCondition(props) { return <PageTemplate {...props} slug="Terms_and_condition" />; }

import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';

function TermsAndCondition({ view, setView, searchTerm, setSearchTerm, cityFilter, setCityFilter, setActiveTab }) {
  const [activeSection, setActiveSection] = useState('intro');

  // পেজ লোড হলে একেবারে উপরে স্ক্রল করবে
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // সাইডবার থেকে ক্লিক করলে নির্দিষ্ট সেকশনে স্মুথ স্ক্রল করার ফাংশন
  const scrollToSection = (id) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      // হেডার যেহেতু ফিক্সড, তাই স্ক্রল করার সময় কিছুটা উপর থেকে জায়গা ছাড়ার জন্য offset দেওয়া হলো
      const y = element.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  // সাইডবারের মেনু লিস্ট (Terms & Conditions এর জন্য)
  const sections = [
    { id: 'intro', title: '1. Introduction' },
    { id: 'definitions', title: '2. Definitions' },
    { id: 'usage', title: '3. Use of the Platform' },
    { id: 'selling', title: '4. Selling a Vehicle' },
    { id: 'buying', title: '5. Buying a Vehicle' },
    { id: 'liability', title: '6. Limitation of Liability' },
    { id: 'law', title: '7. Governing Law' },
  ];

  return (
    <div className="min-h-screen bg-[#f4f7f6] flex flex-col font-sans">
      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />
      
      {/* 🚨 Page Banner 🚨 */}
      <div className="bg-[#002f34] py-16 px-6">
        <div className="max-w-[1200px] mx-auto text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-wide">Terms & <span className="text-[#ef5e33]">Conditions</span></h1>
          <p className="text-gray-300 font-bold mt-4 text-sm md:text-base">
            Last Updated: March 2026 • Bah! Car Plaza
          </p>
        </div>
      </div>

      <main className="flex-1 max-w-[1200px] w-full mx-auto py-12 px-6">
        <div className="flex flex-col md:flex-row gap-10 items-start">
          
          {/* 🚨 LEFT SIDEBAR (Sticky Navigation) 🚨 */}
          <aside className="w-full md:w-1/4 bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden sticky top-28 hidden md:block">
            <div className="p-6 bg-gray-50 border-b border-gray-100">
              <h3 className="font-black text-[#002f34] uppercase text-sm tracking-wider">Quick Links</h3>
            </div>
            <ul className="flex flex-col py-2">
              {sections.map((section) => (
                <li 
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  className={`px-6 py-4 cursor-pointer text-sm font-bold transition-all duration-300 border-l-4 ${
                    activeSection === section.id 
                      ? 'border-[#ef5e33] bg-[#fff3ec] text-[#ef5e33]' 
                      : 'border-transparent text-gray-500 hover:bg-gray-50 hover:text-[#002f34]'
                  }`}
                >
                  {section.title}
                </li>
              ))}
            </ul>
          </aside>

          {/* 🚨 RIGHT CONTENT (Legal Document Style) 🚨 */}
          <div className="w-full md:w-3/4 bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12 text-gray-600 leading-relaxed text-sm md:text-base">
            
            <section id="intro" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">1. Introduction</h2>
              <p className="mb-4">
                These Terms and Conditions ("Terms") govern your use of the <strong className="text-[#002f34]">Bah! Car Plaza</strong> website (https://bahcarplaza.com) and the services provided by us. By accessing, browsing, or using our platform to buy, sell, or inspect used cars, you acknowledge that you have read, understood, and agree to be bound by these Terms.
              </p>
              <p>
                If you do not agree with any part of these terms, you must not use our website or services. We reserve the right to modify these Terms at any time without prior notice.
              </p>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="definitions" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">2. Definitions</h2>
              <ul className="list-disc pl-6 space-y-3 mb-4">
                <li><strong>"Platform":</strong> Refers to the Bah! Car Plaza website, mobile application, and related services.</li>
                <li><strong>"User", "You", "Your":</strong> Refers to anyone accessing or using the Platform, including buyers and sellers.</li>
                <li><strong>"Seller":</strong> An individual or entity listing a vehicle for sale on the Platform.</li>
                <li><strong>"Buyer":</strong> An individual or entity purchasing or intending to purchase a vehicle through the Platform.</li>
              </ul>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="usage" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">3. Use of the Platform</h2>
              <p className="mb-4">By using our platform, you agree to the following conditions:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>You must be at least 18 years old and legally capable of entering into binding contracts.</li>
                <li>You will provide accurate, current, and complete information during the registration and vehicle listing processes.</li>
                <li>You will not use the Platform for any fraudulent, unlawful, or malicious activities.</li>
                <li>You will not attempt to interfere with the proper working of the Platform, including introducing viruses or bypassing security measures.</li>
              </ul>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="selling" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">4. Selling a Vehicle</h2>
              <p className="mb-4">When listing a vehicle for sale on Bah! Car Plaza, you agree that:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>You are the legal owner of the vehicle or have the legal authority to sell it.</li>
                <li>The vehicle details, including kilometers driven, service history, and condition, are true and accurate to the best of your knowledge.</li>
                <li>You agree to subject your vehicle to our mandatory 140-point inspection process. We reserve the right to reject any vehicle that fails to meet our quality standards.</li>
                <li>Once a price is agreed upon and documents are signed, the sale is considered final.</li>
              </ul>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="buying" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">5. Buying a Vehicle</h2>
              <p className="mb-4">When purchasing a vehicle through Bah! Car Plaza, you acknowledge that:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Booking amounts paid to reserve a vehicle are subject to our cancellation and refund policies.</li>
                <li>While we conduct thorough 140-point inspections, it is your responsibility to review the inspection report and take a test drive before finalizing the purchase.</li>
                <li>Full payment must be cleared before the delivery of the vehicle and the initiation of the RC (Registration Certificate) transfer process.</li>
              </ul>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="liability" className="mb-12 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">6. Limitation of Liability</h2>
              <p>
                Bah! Car Plaza acts as an intermediary and facilitator in the buying and selling process. To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, arising from your use of our Platform or services.
              </p>
            </section>

            <div className="w-full h-px bg-gray-100 my-8"></div>

            <section id="law" className="mb-4 scroll-mt-28">
              <h2 className="text-2xl font-black text-[#002f34] mb-4">7. Governing Law & Jurisdiction</h2>
              <p className="mb-4">
                These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts located in West Bengal, India.
              </p>
              <div className="bg-[#f9f9f9] p-6 rounded-2xl border border-gray-200 mt-6">
                <p className="font-bold text-[#002f34] mb-1">Need Clarification?</p>
                <p className="mb-1">If you have any questions regarding these terms, please contact our legal team.</p>
                <p>Email: <a href="mailto:bahcarplaza@gmail.com" className="text-[#ef5e33] hover:underline">bahcarplaza@gmail.com</a></p>
              </div>
            </section>

          </div>
        </div>
      </main>

      <Footer setView={setView} />
    </div>
  );
}

export default TermsAndCondition;